/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { ExperienceLevel, ActivityType, AverageYearlyTransactionsType, AverageYearlyVolumeType } from '../types/utils';

export class UpdateActivityInput {
	levelWithAdvice: ExperienceLevel = ExperienceLevel.NONE

	levelWithAssetManagement: ExperienceLevel = ExperienceLevel.NONE

	levelWithoutAdvice: ExperienceLevel = ExperienceLevel.NONE

	transactionsPerYear: AverageYearlyTransactionsType = AverageYearlyTransactionsType.NONE

	type: ActivityType = ActivityType.WP_SERVICE

	volumePerYear: AverageYearlyVolumeType = AverageYearlyVolumeType.LOW
}